<div class="video-container">
    <iframe [src]="videoAuto_params.urlVideoSafe" width="450" height="800" frameborder="0" webkitallowfullscreen
        mozallowfullscreen allowfullscreen class="heroTranslate"></iframe>
</div>